
import { Language } from '../types';

export const homeTranslations: Record<Language, Record<string, string>> = {
  en: {
    // Hero Section
    heroTitle: "See real profit, per SKU, every morning.",
    heroTitle2: "Pricing, bidding, and forecasting run themselves.",
    heroTitle4: "One dashboard for every channel, product, and margin.",
    heroTitle5: "Know which product, channel, or campaign is losing money — today.",
    heroKicker: "Put your data to work.",
    heroSubtitle: "Most teams don't fully trust their numbers.\nWe turn your scattered data into a clean, solid foundation, and stay to keep it reliable, day after day.",
    heroCtaText: "Let's find a solution together",
    heroExploreCtaText: "See How It Works",
    
    // Services Section
    servicesTitle: "Modular solutions for data, automation, and AI operations.",
    servicesTitlePrefix: "Talk to your data. ",
    servicesTitleHighlight: "Get answers, not reports.",
    servicesSubtitle: "We offer specialized data solutions designed to optimize your business operations, enhance decision-making, and drive sustainable growth.",
    ourExpertise: "Solutions",
    
    // Benefits Section
    whyChooseUs: "Why Choose Us",
    benefitsTitle: "The Stratodata Advantage",
    benefitsSubtitle: "Our approach combines technical excellence with business acumen to deliver solutions that provide real, measurable value.",
    
    // Benefit Items
    tailoredSolutionsTitle: "Tailored Solutions",
    tailoredSolutionsDesc: "We craft bespoke solutions that align perfectly with your unique business objectives and challenges.",
    dataInsightsTitle: "Data-Driven Insights",
    dataInsightsDesc: "Transform raw data into actionable business intelligence with our advanced analytics capabilities.",
    automationTitle: "Automation Efficiency",
    automationDesc: "Streamline operations and reduce costs through intelligent automation of repetitive tasks and workflows.",
    scalableTitle: "Scalable Architecture",
    scalableDesc: "Our solutions grow with your business, providing flexibility and performance at any scale.",
    modernTechTitle: "Modern Technologies",
    modernTechDesc: "We leverage cutting-edge tools and frameworks to ensure your systems remain competitive and future-proof.",
    optimizationTitle: "Continuous Optimization",
    optimizationDesc: "We don't just build and leave; we continuously refine solutions to maximize ROI and performance.",
    
    // CTA Section
    ctaTitle: "Ready to make your data work for you?",
    ctaSubtitle: "Let's turn insight into real business results.",
    exploreServices: "Explore Our Services",
    learnAboutUs: "Learn About Us",
    contactUs: "Contact us",
    contactOurTeam: "Contact our team",
    
    // Contact Form Fields
    formFullName: "What's your full name? *",
    formFullNamePlaceholder: "Jane Smith",
    formWorkEmail: "What's your work email? *",
    formWorkEmailPlaceholder: "jane@company.com",
    formCompany: "What company do you work for?",
    formCompanyPlaceholder: "Big Tech company",
    formCompanySize: "How many employees does your company have?",
    formCompanySizePlaceholder: "1-15",
    formCompanySizeOption1: "1-15",
    formCompanySizeOption2: "16-50",
    formCompanySizeOption3: "50-200",
    formCompanySizeOption4: "more than 200",
    formHowCanWeHelp: "How can we help?",
    formVerifyHuman: "Verify you're human: 7 + 1",
    formVerifyHumanError: "Please enter the correct result.",
    formPrivacyNotice: "By sending this form, you acknowledge that Stratodata will process your personal data to respond to your enquiry. More in our ",
    formPrivacyPolicyLink: "Privacy Policy",
    formPrivacyNoticeEnd: ".",
    
    // Consulting Services
    consultingTitle: "Consulting services",
    consultingTitlePrefix: "Consulting ",
    consultingTitleHighlight: "services",
    consultingSubtitle: "We don't just advise — we build with you and mentor your team to make data your real advantage.",
    
    // Integration Section
    integrationTitle: "Integrations",
    integrationHeading: "Keep the tools your team already knows.",
    integrationSubtitle: "We integrate seamlessly with your existing tools and enhance them with smart automation and secure AI. Change happens smoothly, with our full support from start to finish.",
    seeIntegrations: "See integrations",
    
    // Client Logos Section
    trustedPartnersLabel: "Trusted Partners",
    companiesTitle: "Companies That Trust Us",
    companiesSubtitle: "Trusted by retailers, e-shops and digital businesses",
    clientsListText: "Join our growing list of satisfied clients who have transformed their data operations.",
    
    // Case Studies
    caseStudiesTitle: "Case Studies",
    caseStudiesSubtitle: "Real-world examples of how our solutions have helped businesses achieve their goals.",
    comingSoon: "Case studies coming soon.",
    checkBack: "Check back later for detailed case studies of our client success stories.",
    
    // Solutions Section
    solutionsBadge: "Solutions",
    solutionsHeading: "Modular solutions for data, automation, and AI operations.",
    solutionsSubheading: "Modular by design — start with one, add the rest when you're ready.",
    learnMore: "Learn more",
    solutionsHowItWorksLink: "See how it all comes together",
    
    // Solution items
    solutionDataWarehousingTitle: "Data warehousing",
    solutionDataWarehousingDesc: "Bring all your business data into one trusted place — clean, unified, and always up to date. A solid data warehouse means one truth for every team, and decisions based on facts, not spreadsheets. Solution is built to scale with your size and needs, providing the right performance for optimized costs.",
    solutionDataWarehousingFeature1: "End spreadsheet chaos with one source of truth",
    solutionDataWarehousingFeature2: "Faster reporting and consistent metrics",
    solutionDataWarehousingFeature3: "Reliable foundation for automation and AI",
    
    solutionReportingBITitle: "Reporting & BI",
    solutionReportingBIDesc: "Clear dashboards that show what really matters — so teams align faster, decisions strengthen, and performance improves.",
    solutionReportingBIFeature1: "Actionable metrics instead of endless charts",
    solutionReportingBIFeature2: "Shared visibility across departments",
    solutionReportingBIFeature3: "Managed access - internally and externally",
    
    solutionAutomationsTitle: "Automations",
    solutionAutomationsDesc: "Automate routine work and connect your tools so teams move faster — without fragile scripts or patchwork processes. Use clean and proven data from data warehouse to gain benefits of tailored automation.",
    solutionAutomationsFeature1: "Use available data it to automate your processes",
    solutionAutomationsFeature2: "Save hours weekly across operations, marketing, and finance",
    solutionAutomationsFeature3: "Reduce manual errors and hand-offs",
    
    solutionAITitle: "Talk to your data with AI",
    solutionAIDesc: "Come to the next level of analysis and use your AI interface to directly communicate with your data. Minimal friction to knowledge and tailored analysis to your case enables you to zoom in on the detail needed. No need to talk to the analyst to alter anything. Just ask and question comes back.",
    solutionAIFeature1: "Your data securely exposed to AI tools like Claude or Copilot",
    solutionAIFeature2: "Custom Context Engineering to ensure accuracy of responses",
    solutionAIFeature3: "Training of usage for efficient consumption of tokens",
    solutionAIFeature4: "Governance for secure usage across your organization",
    
    solutionRasSaasTitle: "RAS (SaaS)",
    solutionRasSaasDesc: "Modern modular platform for SMB retailers, which catapults them to the AI age. Connect your marketing, web, ERP and warehouse data under one roof and let the magic happen. Unified profit oriented reporting, built in automations such as dynamic pricing and enabled MCP connection for AI apps. No more spreadsheet hell of static reports.",
    solutionRasSaasFeature1: "Enterprise experience packaged into accessible solution",
    solutionRasSaasFeature2: "Connect crucial datasets: all marketing platforms, web analytics, ERP and warehouse",
    solutionRasSaasFeature3: "No need to provide feeds: enable access and our data engineers will work on the integration",
    solutionRasSaasFeature4: "If you are after maximizing profit, good. RAS was built for you. See it with reports and maximize it with automations.",
    solutionRasSaasFeature5: "Use the available data from RAS as a building material for your AI agentic workflows",
    
    // Consulting Services details
    consultingServicesHeading: "Consulting services",
    consultingDataAdoptionTitle: "Data Adoption Change Management",
    consultingDataAdoptionDesc1: "See every campaign across Google, Facebook, Instagram and more in one place. Read what actually drives profit, and decide where your budget goes based on numbers, not gut feeling.",
    consultingDataAdoptionDesc2: "Our own proven adoption framework guides your teams to superior data literacy and skills which enable them to extract value from data. Make sure your data is applied and used.",
    consultingAIReadinessTitle: "AI Readiness Assessment",
    consultingAIReadinessDesc1: "Before you build AI, make sure your data, processes, and teams are ready.",
    consultingAIReadinessDesc2: "We assess your foundations and create a clear, realistic path to successful AI adoption — without guesswork or buzzwords.",
  },
  de: {
    // Hero Section
    heroTitle: "Echten Gewinn pro Artikel jeden Morgen im Blick.",
    heroTitle2: "Preisgestaltung, Gebote und Prognosen laufen von selbst.",
    heroTitle4: "Ein Dashboard für jeden Kanal, jedes Produkt, jede Marge.",
    heroTitle5: "Wissen Sie noch heute, welches Produkt, welcher Kanal oder welche Kampagne Geld verliert.",
    heroKicker: "Lassen Sie Ihre Daten arbeiten.",
    heroSubtitle: "Die meisten Teams vertrauen ihren Zahlen nicht ganz.\nWir verbinden Vertrieb, Marketing und Finanzen und bleiben, damit alles verlässlich ist, Tag für Tag.",
    heroCtaText: "Kostenloses Erstgespräch",
    heroExploreCtaText: "So funktioniert es",
    
    // Services Section
    servicesTitle: "Modulare Lösungen für Daten-, Automatisierungs- und KI-Operationen.",
    servicesTitlePrefix: "Modulare Lösungen für ",
    servicesTitleHighlight: "Daten-, Automatisierungs- und KI-Operationen.",
    servicesSubtitle: "Wir bieten spezialisierte Datenlösungen, die darauf ausgelegt sind, Ihre Geschäftsprozesse zu optimieren, die Entscheidungsfindung zu verbessern und nachhaltiges Wachstum zu fördern.",
    ourExpertise: "Lösungen",
    
    // Benefits Section
    whyChooseUs: "Warum uns wählen",
    benefitsTitle: "Der Stratodata-Vorteil",
    benefitsSubtitle: "Unser Ansatz kombiniert technische Exzellenz mit Geschäftssinn, um Lösungen zu liefern, die einen realen, messbaren Wert bieten.",
    
    // Benefit Items
    tailoredSolutionsTitle: "Maßgeschneiderte Lösungen",
    tailoredSolutionsDesc: "Wir entwickeln maßgeschneiderte Lösungen, die perfekt auf Ihre einzigartigen Geschäftsziele und Herausforderungen abgestimmt sind.",
    dataInsightsTitle: "Datengestützte Erkenntnisse",
    dataInsightsDesc: "Transformieren Sie Rohdaten in praktische Geschäftsinformationen mit unseren fortschrittlichen Analysefunktionen.",
    automationTitle: "Automatisierungseffizienz",
    automationDesc: "Optimieren Sie Abläufe und reduzieren Sie Kosten durch intelligente Automatisierung von wiederkehrenden Aufgaben und Arbeitsabläufen.",
    scalableTitle: "Skalierbare Architektur",
    scalableDesc: "Unsere Lösungen wachsen mit Ihrem Unternehmen und bieten Flexibilität und Leistung in jedem Maßstab.",
    modernTechTitle: "Moderne Technologien",
    modernTechDesc: "Wir nutzen modernste Tools und Frameworks, um sicherzustellen, dass Ihre Systeme wettbewerbsfähig und zukunftssicher bleiben.",
    optimizationTitle: "Kontinuierliche Optimierung",
    optimizationDesc: "Wir bauen nicht nur und gehen; wir verfeinern kontinuierlich Lösungen, um ROI und Leistung zu maximieren.",
    
    // CTA Section
    ctaTitle: "Bereit, Ihre Daten für sich arbeiten zu lassen?",
    ctaSubtitle: "Lassen Sie uns Erkenntnisse in echte Geschäftsergebnisse umwandeln.",
    exploreServices: "Entdecken Sie unsere Dienstleistungen",
    learnAboutUs: "Erfahren Sie mehr über uns",
    contactUs: "Kontaktieren Sie uns",
    contactOurTeam: "Kontaktieren Sie unser Team",
    
    // Contact Form Fields
    formFullName: "Wie lautet Ihr vollständiger Name? *",
    formFullNamePlaceholder: "Max Mustermann",
    formWorkEmail: "Wie lautet Ihre Arbeits-E-Mail? *",
    formWorkEmailPlaceholder: "max@unternehmen.de",
    formCompany: "Für welches Unternehmen arbeiten Sie?",
    formCompanyPlaceholder: "Großes Tech-Unternehmen",
    formCompanySize: "Wie viele Mitarbeiter hat Ihr Unternehmen?",
    formCompanySizePlaceholder: "1-15",
    formCompanySizeOption1: "1-15",
    formCompanySizeOption2: "16-50",
    formCompanySizeOption3: "50-200",
    formCompanySizeOption4: "mehr als 200",
    formHowCanWeHelp: "Wie können wir Ihnen helfen?",
    formVerifyHuman: "Bestätigen Sie, dass Sie ein Mensch sind: 7 + 1",
    formVerifyHumanError: "Bitte geben Sie das richtige Ergebnis ein.",
    formPrivacyNotice: "Nach dem Absenden Ihrer Anfrage werden Ihre personenbezogenen Daten zur Bearbeitung Ihrer Anfrage verarbeitet. Weitere Informationen: ",
    formPrivacyPolicyLink: "Datenschutzrichtlinie*",
    formPrivacyNoticeEnd: "",
    
    // Consulting Services
    consultingTitle: "Beratungsdienstleistungen",
    consultingTitlePrefix: "Beratungs",
    consultingTitleHighlight: "dienstleistungen",
    consultingSubtitle: "Wir beraten nicht nur — wir bauen mit Ihnen und betreuen Ihr Team, damit Daten zu Ihrem echten Vorteil werden.",
    
    // Integration Section
    integrationTitle: "Integrations",
    integrationHeading: "Behalten Sie die Tools, die Ihr Team bereits kennt.",
    integrationSubtitle: "Wir integrieren uns nahtlos in Ihre bestehenden Tools und erweitern sie mit intelligenter Automatisierung und sicherer KI. Veränderungen geschehen reibungslos, mit unserer vollständigen Unterstützung von Anfang bis Ende.",
    seeIntegrations: "Integrationen ansehen",
    
    // Client Logos Section
    trustedPartnersLabel: "Vertrauenswürdige Partner",
    companiesTitle: "Unternehmen, die uns vertrauen",
    companiesSubtitle: "Vertraut von Einzelhändlern, Online-Shops und digitalen Unternehmen.",
    clientsListText: "Schließen Sie sich unserer wachsenden Liste zufriedener Kunden an, die ihre Datenoperationen transformiert haben.",
    
    // Case Studies
    caseStudiesTitle: "Fallstudien",
    caseStudiesSubtitle: "Praxisbeispiele, wie unsere Lösungen Unternehmen geholfen haben, ihre Ziele zu erreichen.",
    comingSoon: "Fallstudien in Kürze verfügbar.",
    checkBack: "Schauen Sie später nach ausführlichen Fallstudien unserer Kundenerfolgsgeschichten.",
    
    // Solutions Section
    solutionsBadge: "Lösungen",
    solutionsHeading: "Modulare Lösungen für Daten-, Automatisierungs- und KI-Operationen.",
    solutionsSubheading: "Modular von Grund auf — beginnen Sie mit einem und ergänzen Sie den Rest, wenn Sie bereit sind.",
    learnMore: "Mehr erfahren",
    solutionsHowItWorksLink: "So spielt alles zusammen",
    
    // Solution items
    solutionDataWarehousingTitle: "Data Warehousing",
    solutionDataWarehousingDesc: "Bringen Sie alle Ihre Geschäftsdaten an einen vertrauenswürdigen Ort — sauber, vereinheitlicht und immer auf dem neuesten Stand. Ein solides Data Warehouse bedeutet eine einzige Wahrheit für jedes Team und Entscheidungen basierend auf Fakten, nicht auf Tabellenkalkulationen. Die Lösung ist darauf ausgelegt, mit Ihrer Größe und Ihren Bedürfnissen zu skalieren und die richtige Leistung für optimierte Kosten zu bieten.",
    solutionDataWarehousingFeature1: "Beenden Sie Tabellenkalkulations-Chaos mit einer einzigen Quelle der Wahrheit",
    solutionDataWarehousingFeature2: "Schnelleres Reporting und konsistente Metriken",
    solutionDataWarehousingFeature3: "Zuverlässige Grundlage für Automatisierung und KI",
    
    solutionReportingBITitle: "Reporting & BI",
    solutionReportingBIDesc: "Klare Dashboards, die zeigen, was wirklich wichtig ist — damit Teams sich schneller ausrichten, Entscheidungen gestärkt werden und die Leistung sich verbessert.",
    solutionReportingBIFeature1: "Handlungsrelevante Metriken statt endloser Diagramme",
    solutionReportingBIFeature2: "Geteilte Sichtbarkeit über Abteilungen hinweg",
    solutionReportingBIFeature3: "Verwalteter Zugang - intern und extern",
    
    solutionAutomationsTitle: "Automatisierung",
    solutionAutomationsDesc: "Automatisieren Sie Routinearbeit und verbinden Sie Ihre Tools, damit Teams schneller arbeiten — ohne fragile Skripte oder Flickwerkprozesse. Nutzen Sie saubere und bewährte Daten aus dem Data Warehouse, um die Vorteile maßgeschneiderter Automatisierung zu nutzen.",
    solutionAutomationsFeature1: "Nutzen Sie verfügbare Daten, um Ihre Prozesse zu automatisieren",
    solutionAutomationsFeature2: "Sparen Sie wöchentlich Stunden in Betrieb, Marketing und Finanzen",
    solutionAutomationsFeature3: "Reduzieren Sie manuelle Fehler und Übergaben",
    
    solutionAITitle: "Sprechen Sie mit Ihren Daten per KI",
    solutionAIDesc: "Kommen Sie auf die nächste Analyseebene und nutzen Sie Ihre KI-Oberfläche, um direkt mit Ihren Daten zu kommunizieren. Minimale Reibung zum Wissen und maßgeschneiderte Analysen für Ihren Fall ermöglichen den Fokus auf das Nötige. Kein Rückfragen beim Analysten nötig — einfach fragen, die Antwort kommt.",
    solutionAIFeature1: "Ihre Daten sicher für KI-Tools wie Claude oder Copilot bereitgestellt",
    solutionAIFeature2: "Individuelles Context Engineering für präzise Antworten",
    solutionAIFeature3: "Schulung zur effizienten Nutzung und Token-Verbrauch",
    solutionAIFeature4: "Governance für sichere Nutzung in Ihrer Organisation",
    
    solutionRasSaasTitle: "RAS (SaaS)",
    solutionRasSaasDesc: "Moderne modulare Plattform für Einzelhändler (SMB), die sie ins KI-Zeitalter katapultiert. Verbinden Sie Marketing-, Web-, ERP- und Lagerdaten unter einem Dach und lassen Sie die Magie geschehen. Einheitliches gewinnorientiertes Reporting, eingebaute Automatisierungen wie dynamische Preisgestaltung und MCP-Anbindung für KI-Apps. Schluss mit Tabellen-Chaos und statischen Reports.",
    solutionRasSaasFeature1: "Enterprise-Erfahrung in einer zugänglichen Lösung",
    solutionRasSaasFeature2: "Zentrale Anbindung: Marketing-Plattformen, Web-Analytics, ERP und Lager",
    solutionRasSaasFeature3: "Keine Feeds nötig: Zugriff freigeben, unsere Data Engineers übernehmen die Integration",
    solutionRasSaasFeature4: "Profit maximieren? RAS wurde dafür gebaut. Sichtbar in Reports, umsetzbar mit Automatisierungen.",
    solutionRasSaasFeature5: "Nutzen Sie RAS-Daten als Baustein für Ihre KI-Agenten-Workflows",
    
    // Consulting Services details
    consultingServicesHeading: "Beratungsdienstleistungen",
    consultingDataAdoptionTitle: "Daten-Adoptions-Change-Management",
    consultingDataAdoptionDesc1: "Verwalten Sie Werbung über mehrere Plattformen hinweg von einem einzigen Dashboard aus. Überwachen Sie Kampagnen auf Google, Facebook, Instagram und mehr einfach.",
    consultingDataAdoptionDesc2: "Unser eigenes bewährtes Adoptions-Framework führt Ihre Teams zu überlegener Datenkompetenz und Fähigkeiten, die es ihnen ermöglichen, Wert aus Daten zu extrahieren. Stellen Sie sicher, dass Ihre Daten angewendet und genutzt werden.",
    consultingAIReadinessTitle: "KI-Bereitschaftsbewertung",
    consultingAIReadinessDesc1: "Bevor Sie KI aufbauen, stellen Sie sicher, dass Ihre Daten, Prozesse und Teams bereit sind.",
    consultingAIReadinessDesc2: "Wir bewerten Ihre Grundlagen und erstellen einen klaren, realistischen Weg zur erfolgreichen KI-Adoption — ohne Rätselraten oder Buzzwords.",
  },
  sk: {
    // Hero Section
    heroTitle: "Skutočný zisk na produkt, každé ráno na jednom mieste.",
    heroTitle2: "Cenotvorba, PPC ponuky a predikcie bežia samé.",
    heroTitle4: "Jeden dashboard pre každý kanál, produkt aj maržu.",
    heroTitle5: "Zistite ešte dnes, ktorý produkt, kanál alebo kampaň vám berie peniaze.",
    heroKicker: "Put your data to work.",
    heroSubtitle: "Väčšina tímov svojim číslam naplno neverí.\nZ vašich roztrúsených dát postavíme čistý a solídny základ a zostaneme pri vás, aby všetko sedelo deň čo deň.",
    heroCtaText: "Nájdime riešenie spolu",
    heroExploreCtaText: "Pozrite sa, ako to funguje",
    
    // Services Section
    servicesTitle: "Modulárne riešenia pre dáta, automatizáciu a AI.",
    servicesTitlePrefix: "Rozprávajte sa so svojimi dátami. ",
    servicesTitleHighlight: "Získajte odpovede, nie reporty.",
    servicesSubtitle: "Staviame dátové riešenia, s ktorými firma funguje hladšie, rozhoduje lepšie a rastie zdravo.",
    ourExpertise: "Riešenia",
    
    // Benefits Section
    whyChooseUs: "Prečo si vybrať nás",
    benefitsTitle: "Výhody Stratodata",
    benefitsSubtitle: "Rozumieme technike aj biznisu, a preto staviame riešenia, ktorých prínos sa dá zmerať.",
    
    // Benefit Items
    tailoredSolutionsTitle: "Prispôsobené riešenia",
    tailoredSolutionsDesc: "Riešenia staviame na mieru vašim cieľom a problémom, ktoré práve riešite.",
    dataInsightsTitle: "Poznatky z dát",
    dataInsightsDesc: "Zo surových dát urobíme informácie, podľa ktorých sa dá v biznise rozhodovať.",
    automationTitle: "Automatizácia rutiny",
    automationDesc: "Opakované úlohy a postupy necháme bežať automaticky. Ušetríte čas aj náklady.",
    scalableTitle: "Škálovateľná architektúra",
    scalableDesc: "Riešenie rastie spolu s vašou firmou a zvládne aj väčší objem bez straty výkonu.",
    modernTechTitle: "Moderné technológie",
    modernTechDesc: "Pracujeme s modernými nástrojmi, aby vaše systémy obstáli aj o pár rokov.",
    optimizationTitle: "Priebežné vylepšovanie",
    optimizationDesc: "Po spustení neodchádzame. Riešenie ďalej ladíme, aby vám prinášalo čo najviac.",
    
    // CTA Section
    ctaTitle: "Chcete, aby vaše dáta pracovali pre vás?",
    ctaSubtitle: "Poďme z čísel urobiť reálne výsledky.",
    exploreServices: "Pozrite si naše služby",
    learnAboutUs: "Spoznajte nás",
    contactUs: "Kontaktujte nás",
    contactOurTeam: "Kontaktujte náš tím",
    
    // Contact Form Fields
    formFullName: "Aké je vaše celé meno? *",
    formFullNamePlaceholder: "Ján Novák",
    formWorkEmail: "Aký je váš pracovný e-mail? *",
    formWorkEmailPlaceholder: "jan@spolocnost.sk",
    formCompany: "Pre ktorú spoločnosť pracujete?",
    formCompanyPlaceholder: "Veľká technologická spoločnosť",
    formCompanySize: "Koľko zamestnancov má vaša spoločnosť?",
    formCompanySizePlaceholder: "1-15",
    formCompanySizeOption1: "1-15",
    formCompanySizeOption2: "16-50",
    formCompanySizeOption3: "50-200",
    formCompanySizeOption4: "viac ako 200",
    formHowCanWeHelp: "Ako vám môžeme pomôcť?",
    formVerifyHuman: "Overte, že ste človek: 7 + 1",
    formVerifyHumanError: "Zadajte správny výsledok.",
    formPrivacyNotice: "Odoslaním formulára beriete na vedomie, že Stratodata spracuje vaše osobné údaje, aby vám mohla odpovedať. Viac informácií tu: ",
    formPrivacyPolicyLink: "Zásady ochrany osobných údajov*",
    formPrivacyNoticeEnd: "",
    
    // Consulting Services
    consultingTitle: "Konzultačné služby",
    consultingTitlePrefix: "Konzultačné ",
    consultingTitleHighlight: "služby",
    consultingSubtitle: "Neostaneme pri radách. Staviame s vami a učíme váš tím, aby vám dáta dávali skutočný náskok.",
    
    // Integration Section
    integrationTitle: "Integrácie",
    integrationHeading: "Zostaňte pri nástrojoch, ktoré váš tím už pozná.",
    integrationSubtitle: "Napojíme sa na nástroje, ktoré už používate, a doplníme ich o automatizácie a bezpečnú AI. Pri zmene vás podržíme od začiatku až do konca.",
    seeIntegrations: "Zobraziť integrácie",
    
    // Client Logos Section
    trustedPartnersLabel: "Dôveryhodní partneri",
    companiesTitle: "Spoločnosti, ktoré nám dôverujú",
    companiesSubtitle: "Dôverujú nám retaileri, e-shopy a digitálne firmy",
    clientsListText: "Pridajte sa ku klientom, ktorí už majú svoje dáta v poriadku.",
    
    // Case Studies
    caseStudiesTitle: "Prípadové štúdie",
    caseStudiesSubtitle: "Konkrétne príklady, ako naše riešenia pomohli firmám dosiahnuť ich ciele.",
    comingSoon: "Prípadové štúdie čoskoro.",
    checkBack: "Čoskoro tu nájdete podrobné príbehy našich klientov.",
    
    // Solutions Section
    solutionsBadge: "Riešenia",
    solutionsHeading: "Modulárne riešenia pre dáta, automatizáciu a AI.",
    solutionsSubheading: "Všetko je modulárne. Začnite jedným riešením a ďalšie pridajte, keď budete pripravení.",
    learnMore: "Zistiť viac",
    solutionsHowItWorksLink: "Pozrite sa, ako to celé do seba zapadá",
    
    // Solution items
    solutionDataWarehousingTitle: "Dátové sklady",
    solutionDataWarehousingDesc: "Všetky firemné dáta na jednom mieste, ktorému môžete veriť. Čisté, zjednotené a vždy aktuálne. Poriadny dátový sklad dáva všetkým tímom jeden zdroj pravdy, takže sa rozhoduje podľa faktov, a nie podľa tabuliek. Sklad rastie spolu s firmou a potrebný výkon dostanete za rozumnú cenu.",
    solutionDataWarehousingFeature1: "Koniec chaosu v tabuľkách vďaka jednému zdroju pravdy",
    solutionDataWarehousingFeature2: "Rýchlejší reporting a jednotné metriky",
    solutionDataWarehousingFeature3: "Spoľahlivý základ pre automatizáciu a AI",
    
    solutionReportingBITitle: "Reporting a BI",
    solutionReportingBIDesc: "Prehľadné dashboardy, ktoré ukazujú, na čom naozaj záleží. Tímy sa rýchlejšie zhodnú, rozhodujú s väčšou istotou a prejaví sa to aj na výsledkoch.",
    solutionReportingBIFeature1: "Metriky, podľa ktorých sa dá konať, namiesto nekonečných grafov",
    solutionReportingBIFeature2: "Spoločný prehľad naprieč oddeleniami",
    solutionReportingBIFeature3: "Riadený prístup pre ľudí vo firme aj mimo nej",
    
    solutionAutomationsTitle: "Automatizácie",
    solutionAutomationsDesc: "Zautomatizujte rutinnú prácu a prepojte nástroje, aby sa tímy hýbali rýchlejšie. Bez krehkých skriptov a procesov zlepených narýchlo. Automatizácia na mieru stojí na čistých a overených dátach z dátového skladu.",
    solutionAutomationsFeature1: "Využite dáta, ktoré už máte, na automatizáciu procesov",
    solutionAutomationsFeature2: "Ušetrite každý týždeň hodiny práce v prevádzke, marketingu aj financiách",
    solutionAutomationsFeature3: "Menej ručných chýb a odovzdávania práce z ruky do ruky",
    
    solutionAITitle: "Rozprávajte sa so svojimi dátami cez AI",
    solutionAIDesc: "Posuňte analýzu o úroveň vyššie a pýtajte sa svojich dát priamo cez AI rozhranie. K odpovediam sa dostanete rýchlo a môžete ísť do takého detailu, aký práve potrebujete. Ak chcete niečo zmeniť, nemusíte čakať na analytika. Stačí sa opýtať. AI však odpovedá len tak dobre, ako dobré sú dáta, s ktorými pracuje.",
    solutionAIFeature1: "Vaše dáta bezpečne sprístupnené AI nástrojom ako Claude alebo Copilot",
    solutionAIFeature2: "Context Engineering na mieru, aby boli odpovede presné",
    solutionAIFeature3: "Zaškolenie, ako s AI pracovať a nemíňať zbytočne tokeny",
    solutionAIFeature4: "Governance pre bezpečné používanie v celej firme",
    
    solutionRasSaasTitle: "RAS (SaaS)",
    solutionRasSaasDesc: "Moderná modulárna platforma, s ktorou malí a stredne veľkí retaileri vstúpia do éry AI. Prepojte dáta z marketingu, webu, ERP a skladu pod jednu strechu a zvyšok nechajte na nás. Dostanete jednotný reporting zameraný na zisk, zabudované automatizácie, napríklad dynamickú cenotvorbu, a MCP pripojenie pre AI aplikácie. Koniec s nekonečnými statickými reportmi v tabuľkách.",
    solutionRasSaasFeature1: "Skúsenosti z enterprise prostredia v dostupnom riešení",
    solutionRasSaasFeature2: "Prepojte dáta, na ktorých záleží: všetky marketingové platformy, webovú analytiku, ERP a sklad",
    solutionRasSaasFeature3: "Nemusíte nám posielať feedy. Stačí sprístupniť dáta a integráciu urobia naši dátoví inžinieri",
    solutionRasSaasFeature4: "Chcete z biznisu dostať čo najväčší zisk? Presne na to RAS vznikol. V reportoch zisk uvidíte a automatizácie ho pomôžu zvýšiť.",
    solutionRasSaasFeature5: "Dáta z RAS použite ako stavebný materiál pre svojich AI agentov",
    
    // Consulting Services details
    consultingServicesHeading: "Konzultačné služby",
    consultingDataAdoptionTitle: "Zavedenie dát do praxe",
    consultingDataAdoptionDesc1: "Všetky kampane z Googlu, Facebooku, Instagramu a ďalších platforiem vidíte na jednom mieste. Čítajte, čo naozaj prináša zisk, a rozhodujte, kam posunúť rozpočet, na základe čísel, nie pocitu.",
    consultingDataAdoptionDesc2: "Podľa vlastného postupu, ktorý sa nám osvedčil v praxi, naučíme vaše tímy pracovať s dátami tak, aby z nich mali reálny úžitok. Postaráme sa, aby sa dáta vo firme naozaj používali.",
    consultingAIReadinessTitle: "Pripravenosť na AI",
    consultingAIReadinessDesc1: "Skôr než začnete budovať AI, uistite sa, že sú na to pripravené vaše dáta, procesy aj tímy.",
    consultingAIReadinessDesc2: "Zhodnotíme vaše základy a navrhneme jasný a realistický postup, ako AI úspešne zaviesť. Bez hádania a prázdnych buzzwordov.",
  },
  cs: {
    // Hero Section
    heroTitle: "Skutečný zisk na produkt, každé ráno na jednom místě.",
    heroTitle2: "Tvorba cen, PPC nabídky a predikce běží samy.",
    heroTitle4: "Jeden dashboard pro každý kanál, produkt i marži.",
    heroTitle5: "Zjistěte ještě dnes, který produkt, kanál nebo kampaň vám bere peníze.",
    heroKicker: "Nechte svá data pracovat.",
    heroSubtitle: "Většina týmů svým číslům úplně nevěří.\nPropojíme vaše prodeje, marketing a finance a zůstaneme, aby vše sedělo, den co den.",
    heroCtaText: "Bezplatné úvodní volání",
    heroExploreCtaText: "Podívejte se, jak to funguje",
    
    // Services Section
    servicesTitle: "Modulární řešení pro datové, automatizační a AI operace.",
    servicesTitlePrefix: "Modulární řešení pro ",
    servicesTitleHighlight: "datové, automatizační a AI operace.",
    servicesSubtitle: "Nabízíme specializovaná datová řešení navržená k optimalizaci vašich podnikových operací, zlepšení rozhodování a podpoře udržitelného růstu.",
    ourExpertise: "Řešení",
    
    // Benefits Section
    whyChooseUs: "Proč si vybrat nás",
    benefitsTitle: "Výhody Stratodata",
    benefitsSubtitle: "Náš přístup kombinuje technickou dokonalost s obchodním přehledem, abychom dodávali řešení, která přinášejí skutečnou, měřitelnou hodnotu.",
    
    // Benefit Items
    tailoredSolutionsTitle: "Přizpůsobená řešení",
    tailoredSolutionsDesc: "Vytváříme řešení na míru, která dokonale odpovídají vašim jedinečným podnikatelským cílům a výzvám.",
    dataInsightsTitle: "Datové poznatky",
    dataInsightsDesc: "Transformujte surová data na využitelné obchodní informace pomocí našich pokročilých analytických schopností.",
    automationTitle: "Efektivní automatizace",
    automationDesc: "Zefektivněte operace a snižte náklady pomocí inteligentní automatizace opakujících se úloh a pracovních postupů.",
    scalableTitle: "Škálovatelná architektura",
    scalableDesc: "Naše řešení rostou s vaším podnikáním a poskytují flexibilitu a výkon v jakémkoli rozsahu.",
    modernTechTitle: "Moderní technologie",
    modernTechDesc: "Využíváme nejmodernější nástroje a rámce, aby vaše systémy zůstaly konkurenceschopné a připravené na budoucnost.",
    optimizationTitle: "Kontinuální optimalizace",
    optimizationDesc: "Nejen budujeme a odcházíme; neustále vylepšujeme řešení pro maximalizaci návratnosti investic a výkonu.",
    
    // CTA Section
    ctaTitle: "Připraveni nechat vaše data pracovat pro vás?",
    ctaSubtitle: "Proměňme poznatky na skutečné obchodní výsledky.",
    exploreServices: "Prozkoumejte naše služby",
    learnAboutUs: "Poznejte nás",
    contactUs: "Kontaktujte nás",
    contactOurTeam: "Kontaktujte náš tým",
    
    // Contact Form Fields
    formFullName: "Jaké je vaše celé jméno? *",
    formFullNamePlaceholder: "Jan Novák",
    formWorkEmail: "Jaký je váš pracovní e-mail? *",
    formWorkEmailPlaceholder: "jan@spolecnost.cz",
    formCompany: "Pro jakou společnost pracujete?",
    formCompanyPlaceholder: "Velká technologická společnost",
    formCompanySize: "Kolik zaměstnanců má vaše společnost?",
    formCompanySizePlaceholder: "1-15",
    formCompanySizeOption1: "1-15",
    formCompanySizeOption2: "16-50",
    formCompanySizeOption3: "50-200",
    formCompanySizeOption4: "více než 200",
    formHowCanWeHelp: "Jak vám můžeme pomoci?",
    formVerifyHuman: "Ověřte, že jste člověk: 7 + 1",
    formVerifyHumanError: "Zadejte správný výsledek.",
    formPrivacyNotice: "Po odeslání vašeho požadavku budou vaše osobní údaje zpracovány za účelem vyřízení vašeho dotazu. Více informací zde: ",
    formPrivacyPolicyLink: "Zásady ochrany osobních údajů*",
    formPrivacyNoticeEnd: "",
    
    // Consulting Services
    consultingTitle: "Konzultační služby",
    consultingTitlePrefix: "Konzultační ",
    consultingTitleHighlight: "služby",
    consultingSubtitle: "Nejenže poradíme — budujeme s vámi a mentorujeme váš tým, aby data byla vaší skutečnou výhodou.",
    
    // Integration Section
    integrationTitle: "Integrace",
    integrationHeading: "Ponechte si nástroje, které váš tým už zná.",
    integrationSubtitle: "Bezproblémově se integrujeme do vašich existujících nástrojů a rozšiřujeme je inteligentní automatizací a bezpečnou AI. Změny probíhají plynule, s naší plnou podporou od začátku do konce.",
    seeIntegrations: "Zobrazit integrace",
    
    // Client Logos Section
    trustedPartnersLabel: "Důvěryhodní partneři",
    companiesTitle: "Společnosti, které nám důvěřují",
    companiesSubtitle: "Důvěřují nám maloobchodníci, e-shopy a digitální firmy.",
    clientsListText: "Přidejte se k našemu rostoucímu seznamu spokojených klientů, kteří transformovali své datové operace.",
    
    // Case Studies
    caseStudiesTitle: "Případové studie",
    caseStudiesSubtitle: "Praktické příklady toho, jak naše řešení pomohla firmám dosáhnout jejich cílů.",
    comingSoon: "Případové studie brzy.",
    checkBack: "Vraťte se později pro podrobné případové studie našich úspěšných klientských příběhů.",
    
    // Solutions Section
    solutionsBadge: "Řešení",
    solutionsHeading: "Modulární řešení pro datové, automatizační a AI operace.",
    solutionsSubheading: "Modulární už z podstaty — začněte jedním a zbytek přidejte, až budete připraveni.",
    learnMore: "Zjistit více",
    solutionsHowItWorksLink: "Podívejte se, jak to všechno funguje dohromady",
    
    // Solution items
    solutionDataWarehousingTitle: "Datový sklad",
    solutionDataWarehousingDesc: "Spojte všechna vaše obchodní data na jednom důvěryhodném místě — čistá, sjednocená a vždy aktuální. Solidní datový sklad znamená jeden zdroj pravdy pro každý tým a rozhodování založené na faktech, ne na tabulkách. Řešení je postaveno tak, aby rostlo s vaší velikostí a potřebami, poskytujíc správný výkon pro optimalizované náklady.",
    solutionDataWarehousingFeature1: "Ukončete chaos tabulek jediným zdrojem pravdy",
    solutionDataWarehousingFeature2: "Rychlejší reportování a konzistentní metriky",
    solutionDataWarehousingFeature3: "Spolehlivý základ pro automatizaci a AI",
    
    solutionReportingBITitle: "Reportování a BI",
    solutionReportingBIDesc: "Jasné dashbordy, které ukazují, na čem skutečně záleží — aby týmy rychleji spolupracovaly, rozhodnutí byla pevnější a výkon se zlepšoval.",
    solutionReportingBIFeature1: "Akční metriky místo nekonečných grafů",
    solutionReportingBIFeature2: "Sdílená viditelnost napříč odděleními",
    solutionReportingBIFeature3: "Řízený přístup - interně i externě",
    
    solutionAutomationsTitle: "Automatizace",
    solutionAutomationsDesc: "Automatizujte rutinní práci a propojte své nástroje, aby týmy pracovaly rychleji — bez křehkých skriptů nebo provizorních procesů. Používejte čistá a osvědčená data z datového skladu k získání výhod přizpůsobené automatizace.",
    solutionAutomationsFeature1: "Použijte dostupná data k automatizaci svých procesů",
    solutionAutomationsFeature2: "Ušetřete hodiny týdně napříč operacemi, marketingem a financemi",
    solutionAutomationsFeature3: "Snižte manuální chyby a předávání",
    
    solutionAITitle: "Mluvte se svými daty přes AI",
    solutionAIDesc: "Přejděte na další úroveň analýzy a používejte své AI rozhraní pro přímou komunikaci s daty. Minimální tření při získávání poznatků a analýzy na míru vám umožní zaměřit se na potřebné detaily. Nemusíte žádat analytika o změny — stačí se zeptat a odpověď přijde.",
    solutionAIFeature1: "Vaše data bezpečně vystavená AI nástrojům jako Claude nebo Copilot",
    solutionAIFeature2: "Vlastní kontextové inženýrství pro přesnost odpovědí",
    solutionAIFeature3: "Školení používání pro efektivní spotřebu tokenů",
    solutionAIFeature4: "Governance pro bezpečné používání v celé organizaci",
    
    solutionRasSaasTitle: "RAS (SaaS)",
    solutionRasSaasDesc: "Moderní modulární platforma pro SMB maloobchodníky, která je katapultuje do věku AI. Propojte marketingová, webová, ERP a skladová data pod jednou střechou a nechte se překvapit. Jednotné ziskově orientované reportování, vestavěné automatizace jako dynamické cenotvorba a MCP pro AI aplikace. Žádné moře tabulek a statických reportů.",
    solutionRasSaasFeature1: "Enterprise zkušenost zabalená do dostupného řešení",
    solutionRasSaasFeature2: "Propojení klíčových dat: marketingové platformy, webová analytika, ERP a sklad",
    solutionRasSaasFeature3: "Nemusíte poskytovat feedy: umožněte přístup a naši datoví inženýři se postarají o integraci",
    solutionRasSaasFeature4: "Chcete maximalizovat zisk? RAS byl vytvořen pro vás. Viditelné v reportech, maximalizované automatizacemi.",
    solutionRasSaasFeature5: "Použijte data z RAS jako stavební materiál pro vaše AI agentní workflow",
    
    // Consulting Services details
    consultingServicesHeading: "Konzultační služby",
    consultingDataAdoptionTitle: "Změnový management adopce dat",
    consultingDataAdoptionDesc1: "Spravujte reklamy napříč více platformami z jednoho dashboardu. Snadno dohlížejte na kampaně na Googlu, Facebooku, Instagramu a dalších.",
    consultingDataAdoptionDesc2: "Náš vlastní osvědčený rámec adopce vede vaše týmy k vynikající datové gramotnosti a dovednostem, které jim umožňují získávat hodnotu z dat. Ujistěte se, že vaše data jsou aplikována a používána.",
    consultingAIReadinessTitle: "Hodnocení připravenosti na AI",
    consultingAIReadinessDesc1: "Než začnete budovat AI, ujistěte se, že vaše data, procesy a týmy jsou připraveny.",
    consultingAIReadinessDesc2: "Posuzujeme vaše základy a vytváříme jasnou, realistickou cestu k úspěšné adopci AI — bez dohadů nebo buzzwords.",
  }
};
